import { Breadcrumb } from 'components/breadcrumb'
import { ATIVIDADE_COLETIVA_GESTAO_GRUPOS_PATH } from 'components/layout/SideMenu/SideMenuItems'
import { PecSwitch, PrivateRoute } from 'components/route'
import { Fragment } from 'react'
import Permissions from 'types/Permissions'

import { AtividadeColetivaGruposEditarView } from './AtividadeColetivaGruposEditarView'
import { AtividadeColetivaGruposListaView } from './AtividadeColetivaGruposListaView'
import { AtividadeColetivaGruposRegistrarView } from './AtividadeColetivaGruposRegistrarView'
import { AtividadeColetivaGruposView } from './visualizar/AtividadeColetivaGruposView'

export function AtividadeColetivaGruposRootView() {
  return (
    <Fragment>
      <Breadcrumb title='Gestão de grupos de atividade coletiva' />

      <PecSwitch>
        <PrivateRoute
          path={`${ATIVIDADE_COLETIVA_GESTAO_GRUPOS_PATH}/registrar`}
          component={AtividadeColetivaGruposRegistrarView}
          permission={Permissions.cds.fichaDeAtividadeColetiva.cadastrarEditarEExcluir}
        />
        <PrivateRoute
          exact
          path={ATIVIDADE_COLETIVA_GESTAO_GRUPOS_PATH}
          component={AtividadeColetivaGruposListaView}
          permission={Permissions.cds.fichaDeAtividadeColetiva}
        />
        <PrivateRoute
          path={`${ATIVIDADE_COLETIVA_GESTAO_GRUPOS_PATH}/visualizar/:atividadeColetivaGrupoId`}
          component={AtividadeColetivaGruposView}
          permission={Permissions.cds.fichaDeAtividadeColetiva}
        />
        <PrivateRoute
          path={`${ATIVIDADE_COLETIVA_GESTAO_GRUPOS_PATH}/editar/:atividadeColetivaGrupoId`}
          component={AtividadeColetivaGruposEditarView}
          permission={Permissions.cds.fichaDeAtividadeColetiva.cadastrarEditarEExcluir}
        />
      </PecSwitch>
    </Fragment>
  )
}
